import {
    LAST_24_HOURS_VALUE, LAST_7_DAYS_VALUE, LAST_MONTH_VALUE,
    LAST_3_MONTHS_VALUE, LAST_SIX_MONTHS, ANOTHER_PERIOD_VALUE, STATUSES, TYPES
} from './constants';

export const periods = [
    { label: 'filter.periods.hours', value: LAST_24_HOURS_VALUE },
    { label: 'filter.periods.week', value: LAST_7_DAYS_VALUE },
    { label: 'filter.periods.oneMonth', value: LAST_MONTH_VALUE },
    { label: 'filter.periods.threeMonth', value: LAST_3_MONTHS_VALUE },
    { label: 'filter.periods.sixMonth', value: LAST_SIX_MONTHS },
    { label: 'filter.periods.anotherPeriod', value: ANOTHER_PERIOD_VALUE }
];

export const statuses = Object.values(STATUSES).map(status => ({
    label: `filter.statuses.${status}`, value: status
}));

export const types = [
    { label: 'filter.types.all', value: TYPES.ALL },
    { label: 'filter.types.deposit', value: TYPES.DEPOSIT },
    { label: 'filter.types.withdraws', value: TYPES.WITHDRAW }
];
